import { mount } from '../../dom-lifecycle';

mount('[data-stepper]', (stepper, refs) => {
    const swap = current => {
        refs.all.step.forEach(step => step.hidden = step !== current);
        window.scrollTo(0, 0);
        current.querySelectorAll('.auth-content').forEach(el => el.scrollTop = 0);
    };
    const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const show = current => {
        if (!document.startViewTransition || prefersReducedMotion) {
            swap(current);
            return;
        }
        document.startViewTransition(() => swap(current));
    };

    refs.all.next.forEach(button => {
        const step = button.closest('[data-ref="step"]');
        button.addEventListener('click', () => show(step.nextElementSibling));
    });

    refs.all.back.forEach(button => {
        const step = button.closest('[data-ref="step"]');
        button.addEventListener('click', () => show(step.previousElementSibling));
    });

    refs.all.gate.forEach((gate, i) => {
        const button = gate.closest('[data-ref="step"]').querySelector('[data-ref="next"]');
        gate.addEventListener('change', () => button.disabled = !gate.checked);
    });
});
